import {
	getSessionCookieItem,
	setSessionCookieItem,
	removeSessionCookieItem,
} from './sessionCookie';

const cookieConsentKeyName = 'cookies_accepted';

export const getCookieConsent = (): string => {
	const cookieConsent = getSessionCookieItem(cookieConsentKeyName);

	return cookieConsent;
};

export const setCookieConsent = (cookieConsentValue: string) => {
	setSessionCookieItem(cookieConsentKeyName, cookieConsentValue);
};

export const removeCookieConsent = () => {
	removeSessionCookieItem(cookieConsentKeyName);
};
